import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '@env/environment';
import { AtsMessage } from '@shared/models/AtsMessage';

@Injectable({ providedIn: 'root' })
export class AtsReplicationService {
  private readonly url = environment.API_BASE_URL;

  constructor(private readonly http: HttpClient) {}

  refreshJob(message: AtsMessage): Observable<AtsMessage> {
    const params = {
      direction: 'OUT',
    };

    return this.http.post<AtsMessage>(
      `${this.url}/replication/${message.entityType.toLowerCase()}/messages`,
      message,
      { params },
    );
  }
}
